import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Panel } from '@ixicare/ui';
import SitePlaneListContainer from '../containers/SitePlaneList';
import SiteSettingsFormContainer from '../containers/SiteForm';
import siteWrapper, { SiteWrapperProps } from '../utils/siteWrapper';
import { t } from '~i18n';
type BuildingSettingsCreatePageProps = SiteWrapperProps;

const BuildingSettingsCreatePage: React.FC<BuildingSettingsCreatePageProps> = ({ site }) => {
  const siteName = site.name;
  const { hash } = useLocation();

  // React Router doesn't auto-scroll to hash anchors. If we land here with #floors
  // (or any other id), scroll to it on mount / hash change.
  React.useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [hash]);

  return (
    <>
      <Panel>
        <Panel.Title>{t('site.form.titles.main', { siteName })}</Panel.Title>
        <SiteSettingsFormContainer key={site.uuid} site={site} />
      </Panel>
      <Panel id="floors">
        <Panel.Title>{t('site.form.titles.floors', { siteName })}</Panel.Title>
        <SitePlaneListContainer site={site} />
      </Panel>
    </>
  );
};
export default siteWrapper(BuildingSettingsCreatePage);
